import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { addTag, deleteTag, getTagDetail, getTagList, tagAssignMember, updateTag } from "./tagAPI";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { Modal, Button } from "react-bootstrap";
import Select, { MultiValue } from "react-select";
import { userList } from "../leads/logcall_api";
import ResponseModal from "../../../core/modals/response_modal";

interface Tag {
  id: number;
  name: string;
  type?: string;
}
interface User {
  id: number;
  uuid: string;
  username: string;
  role: string;
}
const TagList: React.FC = () => {
  useEffect(() => {
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "auto";
  }, []);
  const { tagId } = useParams();
  const [tags, setTags] = useState<Tag[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [response, setResponse] = useState<{ status: "success" | "error"; message: string } | null>(null);
  const [tagName, setTagName] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [editTagName, setEditTagName] = useState("");
  const [selectedTag, setSelectedTag] = useState<{ id: number; name: string } | null>(null);
  const [selectedMemberIds, setSelectedMemberIds] = useState<number[]>([]);
  const [selectedTagId, setSelectedTagId] = useState<number>();
  const [listUser, setListUser] = useState<User[]>([]);

  const [error, setError] = useState("");
  const fetchUser = async () => {
    try {
      const userTenantId = Number(localStorage.getItem("userTenantId"));
      console.log("UserTenantIDabcabc: ", userTenantId)
      const response = await userList(userTenantId);
      setListUser(response.data.data || []);
    } catch (err) {
      console.error("Error fetching log calls:", err);
      setError("Failed to load log calls.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const [showAssignMemberModal, setShowAssignMemberModal] = useState(false);
  const handleAssignMember = async () => {
    try {
      await tagAssignMember(selectedTagId, selectedMemberIds);
      setResponse({ status: "success", message: "Tags assigned successfully!" });
      setSelectedMemberIds([]);
      setShowAssignMemberModal(false);
    } catch (error) {
      console.error("Error assigning tag:", error);
      setResponse({ status: "error", message: "Failed to assign tags. Please try again." });
    } finally {
      setShowMessageModal(true);
    }
  };

  const fetchTags = async () => {
    setLoading(true);
    try {
      const id = localStorage.getItem("userId");
      if (!id) return;
      const response = await getTagList();
      setTags(response.data.data || []);
    } catch (error) {
      console.error("Error fetching tags:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {

    fetchTags();
  }, []);

  const handleUpdateTag = async () => {
    try {
      if (!editTagName.trim() || !selectedTag) {
        setResponse({ status: "error", message: "Tag name cannot be empty!" });
        return;
      }

      await updateTag(selectedTag.id, editTagName);

      setTags((prevTags) =>
        prevTags.map((tag) =>
          tag.id === selectedTag.id ? { ...tag, name: editTagName } : tag
        )
      );

      setResponse({ status: "success", message: "Tag updated successfully!" });
      setShowEditModal(false);
    } catch (error) {
      console.error("Error updating tag:", error);
      setResponse({ status: "error", message: "Failed to update tag." });
    } finally {
      setShowMessageModal(true);
    }
  };

  const handleDeleteTag = async () => {
    try {
      if (!selectedTag) {
        setResponse({ status: "error", message: "No tag selected for deletion!" });
        return;
      }

      await deleteTag(selectedTag.id);

      setTags((prevTags) => prevTags.filter((tag) => tag.id !== selectedTag.id));

      setResponse({ status: "success", message: "Tag deleted successfully!" });
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Error deleting tag:", error);
      setResponse({ status: "error", message: "Failed to delete tag." });
    } finally {
      setShowMessageModal(true);
    }
  };

  const handleSaveTag = async () => {
    try {
      if (!tagName.trim()) {
        setResponse({ status: "error", message: "Tag name cannot be empty!" });
        return;
      }

      const userId = localStorage.getItem("userId");
      if (!userId) {
        setResponse({ status: "error", message: "User ID not found!" });
        return;
      }

      const response = await addTag([{ name: tagName, memberId: userId }]);
      console.log("API Response:", response.data);

      if (response.data && response.data.data) {
        // setTags((prevTags) => [...prevTags, response.data.data]);
        fetchTags();
      }

      setResponse({ status: "success", message: "Tag added successfully!" });
      setTagName("");
      setShowModal(false);
    } catch (error) {
      console.error("Error adding tag:", error);
      setResponse({ status: "error", message: "Failed to add tag." });
    } finally {
      setShowMessageModal(true);
    }
  };

  const columns = [
    {
      title: "Tag Name",
      dataIndex: "name",
      render: (text: string, record: Tag) => (
        <Link to={`/tags/detail/${record.id}`} className="title-name">
          {text}
        </Link>
      ),
      sorter: (a: Tag, b: Tag) => a.name.localeCompare(b.name),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text: string, record: Tag) => (
        <div className="dropdown table-action">
          <Link to="#" className="action-icon" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v"></i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <button
              className="dropdown-item"
              onClick={() => {
                setSelectedTag(record);
                setEditTagName(record.name);
                setShowEditModal(true);
              }}
            >
              <i className="ti ti-edit text-blue"></i> Edit
            </button>
            <button
              className="dropdown-item"
              onClick={() => {
                setSelectedTag(record);
                setShowDeleteModal(true);
              }}
            >
              <i className="ti ti-trash text-danger"></i> Delete
            </button>
          </div>
        </div >
      ),
    }
  ];

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-4">
                    <h4 className="page-title">
                      Tag<span className="count-title">{tags.length}</span>
                    </h4>
                  </div>
                  <div className="col-8 text-end">
                    <div className="head-icons">
                    </div>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="card">
                <div className="card-header">
                  {/* Search */}
                  <div className="row align-items-center">
                    <div className="col-sm-4">
                      <div className="icon-form mb-3 mb-sm-0">
                        <span className="form-icon">
                          <i className="ti ti-search" />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search Pipeline"
                        />
                      </div>
                    </div>
                  </div>
                  {/* /Search */}
                </div>

                <div className="card-body">

                  <>
                    {/* Filter */}
                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                      <div className="d-flex align-items-center flex-wrap row-gap-2">
                        <div className="dropdown me-2">
                          <Link
                            to="#"
                            className="dropdown-toggle"
                            data-bs-toggle="dropdown"
                          >
                            <i className="ti ti-sort-ascending-2 me-2" />
                            Sort
                          </Link>
                          <div className="dropdown-menu  dropdown-menu-start">
                            <ul>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Ascending
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Descending
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Recently Viewed
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Recently Added
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="dropdown">
                          <Link
                            to="#"
                            className="dropdown-toggle"
                            data-bs-toggle="dropdown"
                          >
                            <i className="ti ti-package-export me-2" />
                            Export
                          </Link>
                          <div className="dropdown-menu  dropdown-menu-end">
                            <ul>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-file-type-pdf text-danger me-1" />
                                  Export as PDF
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-file-type-xls text-green me-1" />
                                  Export as Excel{" "}
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex align-items-center flex-wrap row-gap-2">

                        <Button className="btn btn-primary" onClick={() => setShowModal(true)}>
                          <i className="ti ti-square-rounded-plus me-2" />
                          Add Tag
                        </Button>
                      </div>
                    </div>
                    {/* /Filter */}
                  </>
                  {/* Pipeline List */}
                  <div className="table-responsive custom-table">
                    <Table dataSource={tags} columns={columns} />
                  </div>
                  <div className="row align-items-center">
                    <div className="col-data-6">
                      <div className="datatable-length" />
                    </div>
                    <div className="col-md-6">
                      <div className="datatable-paginate" />
                    </div>
                  </div>
                  {/* /Pipeline List */}
                  {/* Add Tag */}
                  <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                    <Modal.Header closeButton>
                      <Modal.Title>Add New Tag</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="mb-3">
                        <label className="col-form-label">Tag Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter tag name"
                          value={tagName}
                          onChange={(e) => setTagName(e.target.value)}
                          required
                        />
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                      </Button>
                      <Button variant="primary" onClick={handleSaveTag}>
                        Save
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
                  {/* /Add Tag */}
                  {/* Edit Tag Modal */}
                  <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
                    <Modal.Header closeButton>
                      <Modal.Title>Edit Tag</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="mb-3">
                        <label className="col-form-label">Tag Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter tag name"
                          value={editTagName}
                          onChange={(e) => setEditTagName(e.target.value)}
                          required
                        />
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                        Cancel
                      </Button>
                      <Button variant="primary" onClick={handleUpdateTag}>
                        Update
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
                  {/* /Edit Tag Modal */}
                  {/* Delete Tag Modal */}
                  <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                    <Modal.Header closeButton>
                      <Modal.Title>Delete Tag</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      Are you sure you want to delete this tag: <strong>{selectedTag?.name}</strong>?
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                      </Button>
                      <Button variant="danger" onClick={handleDeleteTag}>
                        Delete
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
                  {/* /Delete Tag Modal */}
                  {/* Assign Modal */}
                  {showAssignMemberModal && (
                    <div
                      className="modal custom-modal show d-block"
                      role="dialog"
                      tabIndex={-1}
                    >
                      <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Assign Member</h5>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => setShowAssignMemberModal(false)}
                              aria-label="Close"
                            >
                              <i className="ti ti-x" />
                            </button>
                          </div>

                          <div className="modal-body">
                            <Select
                              isMulti
                              options={listUser.map(user => ({
                                value: user.id,
                                label: user.username,
                              }))}
                              onChange={(selectedOptions) =>
                                setSelectedMemberIds(
                                  selectedOptions ? selectedOptions.map(user => user.value) : []
                                )
                              }
                              placeholder="Select User"
                            />
                          </div>

                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-light"
                              onClick={() => setShowAssignMemberModal(false)}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={handleAssignMember}
                            >
                              Assign
                            </button>
                          </div>

                          <ResponseModal
                            show={showMessageModal}
                            onClose={() => setShowMessageModal(false)}
                            response={response}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
};
export default TagList;
